export default __webpack_public_path__ + "3fca35bcb4b039854b7cfe84076c5cd2.png";